import { Button, Modal } from 'antd';
import { usePermissionDeniedStore } from '@/store/permissionDenied.store';

const PERMISSION_DENIED_MODAL_Z_INDEX = 2147483647;

/**
 * 接口返回 403 后阻止用户继续操作当前页面。
 *
 * 返回平台使用 replace，避免通过浏览器后退再次进入无权限页面。
 */
export function PermissionDeniedModal() {
  const open = usePermissionDeniedStore((state) => state.open);
  const hide = usePermissionDeniedStore((state) => state.hide);

  const returnToDashboard = () => {
    window.location.replace('/dashboard');
  };

  return (
    <Modal
      open={open}
      closable
      maskClosable={false}
      keyboard={false}
      onCancel={hide}
      width={520}
      zIndex={PERMISSION_DENIED_MODAL_Z_INDEX}
      title="暂无操作权限"
      footer={[
        <Button key="cancel" onClick={hide}>
          取消
        </Button>,
        <Button key="return" type="primary" onClick={returnToDashboard}>
          返回平台
        </Button>,
      ]}
    >
      <span> 当前账号没有执行该操作所需的权限，请联系租户管理员授权。</span>
    </Modal>
  );
}
